import axios from '@/libs/api.request'

// 商品列表
export const goodsPage = (info) => {
  return axios.request({
    url: 'food/page',
    data: info,
    method: 'post',
  })
}
// 商品修改
export const goodsUpdate = (info) => {
  return axios.request({
    url: 'food/update',
    data: info,
    method: 'post',
  })
}
// 商品添加
export const goodsAdd = (info) => {
  return axios.request({
    url: 'food/add',
    data: info,
    method: 'post',
  })
}
// 商品删除
export const goodsDel = (info) => {
  return axios.request({
    url: 'food/del',
    data: info,
    method: 'post',
  })
}
// 商品分类列表
export const goodsTypePage = (info) => {
  return axios.request({
    url: 'foodType/page',
    data: info,
    method: 'post',
  })
}

// 获取库存预警商品
export const getLowStockGoods = (threshold) => {
  return axios.request({
    url: 'food/low-stock',
    method: 'post',
    data: { threshold }
  })
}

// 单独更新商品状态（上架/下架）
export const updateGoodsStatus = (info) => {
  return axios.request({
    url: 'food/update-status',
    data: info,
    method: 'post',
  })
}

// 批量更新商品状态（上架/下架）
export const batchUpdateStatus = (info) => {
  return axios.request({
    url: 'food/batch-status',
    data: info,
    method: 'post',
  })
}

// 批量更新库存
export const batchUpdateStock = (info) => {
  return axios.request({
    url: 'food/batch-stock',
    data: info,
    method: 'post',
  })
}

// 批量更新价格
export const batchUpdatePrice = (info) => {
  return axios.request({
    url: 'food/batch-price',
    data: info,
    method: 'post',
  })
}

// 批量删除商品
export const batchDeleteGoods = (ids) => {
  return axios.request({
    url: 'food/batch-delete',
    data: { ids },
    method: 'post',
  })
}

// 导出商品数据
export const exportGoods = (info) => {
  return axios.request({
    url: 'food/export',
    data: info,
    method: 'post',
    responseType: 'blob',
  })
}

// 导入商品数据
export const importGoods = (formData) => {
  return axios.request({
    url: 'food/import',
    data: formData,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取商品统计
export const getGoodsStats = () => {
  return axios.request({
    url: 'food/stats',
    method: 'get',
  })
}
